module.exports = __webpack_public_path__ + "static/media/1st_banner_mobile.28c61b25.png";